import React, { useEffect, useRef, useState } from "react";
import "../../../css/VerticalCarousel.css";
import {
  API_TOKEN_NAME,
  IMAGE_URL,
  SITE_URL,
  WEBSITEPAGE_URL,
  USER_ID,
  USER_LOCAL_ID,
} from "../../../constants";
const HomeSlider = ({ banners }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [initializer, setInitializer] = useState(false);

  const goToIndex = (index) => {
    if (index < 0) {
      index = banners.length - 1; // Go to the last slide if it's less than 0
    } else if (index >= banners.length) {
      index = 0; // Go to the first slide if it exceeds the length
    }
    setActiveIndex(index);
  };
  const nextSlide = () => {
    goToIndex(activeIndex + 1);
  };

  setTimeout(() => {
    setInitializer(true);
  }, 5000);
  // Automatically transition to the next slide
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 3000); // Change slide every 3 seconds

    return () => clearInterval(interval); // Clean up the interval on component unmount
  }, [activeIndex, initializer]);

  /* onst nextSlide = () => {
    goToIndex(activeIndex + 1);
  }; */

  const prevSlide = () => {
    goToIndex(activeIndex - 1);
  };
  return (
    <div
      id="carouselExampleIndicators"
      className="carousel slide vertical h-100"
    >
      <div className="carousel-inner h-100" style={{ borderRadius: "5px" }}>
        {banners.map((item, index) => (
          <div
            key={item.id}
            className={`carousel-item h-100 ${
              index === activeIndex ? "active" : ""
            }`}
          >
            <img
              style={{
                width: "100%",
                height: "100%",
                maxHeight: "574px",
                objectFit: "cover",
              }}
              // src={`/assets/images/new_bgc.jpg`}
              src={`${IMAGE_URL}${item ? item.image_path : ""}`}
              alt=""
              className="img-fluid"
            />
          </div>
        ))}
        <ol className="carousel-indicators">
          {banners.map((item, index) => (
            <div
              key={item.id}
              className="d-flex justify-content-center align-items-center mb-1"
              style={{
                width: "20px",
                height: "20px",
                borderRadius: "50%",
                border: index === activeIndex ? "1px solid #AF9763" : "",
                backgroundColor: "transparent",
                cursor: "pointer",
              }}
              onClick={() => goToIndex(index)}
            >
              <li
                style={{
                  backgroundColor: index === activeIndex ? "#AF9763" : "#fff",
                }}
              ></li>
            </div>
          ))}
        </ol>
      </div>
    </div>
  );
};

export default HomeSlider;



// WEBPACK FOOTER //
// ./src/component/frontend/commonsections/HomeSlider.js